// extracted by mini-css-extract-plugin
export default {"favActive":"ReportPicker_favActive__5FXe0","description":"ReportPicker_description__3KBN3"};